import React from "react";
import { Link } from "react-router-dom";

export default function PageHero({ image, title, subtitle, breadcrumbs }) {
  return (
    <section className="page-hero-image relative" data-testid="page-hero">
      <div className="absolute inset-0 z-0">
        <img
          src={image}
          alt=""
          className="w-full h-full object-cover"
          style={{ objectPosition: "center 40%" }}
          width={1140}
          height={500}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/65" />
      </div>
      <div className="max-w-[1140px] mx-auto px-4 lg:px-8 relative z-10 text-center">
        {breadcrumbs && (
          <div className="flex items-center justify-center gap-2 mb-6 flex-wrap">
            {breadcrumbs.map((crumb, i) => (
              <React.Fragment key={i}>
                {i > 0 && <span className="text-white/40 text-sm">/</span>}
                {crumb.to ? (
                  <Link to={crumb.to} className="text-white/50 text-sm no-underline hover:text-white/80 transition-colors">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-sm text-white font-medium">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>
        )}
        <h1
          className="text-3xl sm:text-4xl lg:text-5xl font-semibold max-w-3xl mx-auto text-white"
          style={{ fontFamily: "'Playfair Display', serif" }}
          data-testid="page-hero-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-white/60 mt-6 max-w-2xl mx-auto leading-relaxed text-base" data-testid="page-hero-subtitle">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
